import { DropdownLayout } from '../components';
import type { StyleProps } from './types';

export function Style14({ items, onClick }: StyleProps) {
  return (
    <DropdownLayout
      items={items}
      withFlag
      flagStyle="rounded"
      onClick={onClick}
    />
  );
}
